/* eslint-disable react-hooks/rules-of-hooks */
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useTranslation } from "react-i18next";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { GeneralFieldController } from "./general-field-controller";
import { getEnumValues } from "../utils/get-enum-values";
import { TestType, TestUoMType } from "../models/generated/graphql";
import { useFieldValue } from "formik";
import { SelectableValue } from "../models/common/selectable-value";

export class TestTypeFieldController extends GeneralFieldController {
	public currentIndex = 0;
	override useControlProps(path: string): FlexControlProps {
		this.currentIndex = +(path.split(".").find((e) => Number.isInteger(+e)) || 0);
		const { t } = useTranslation();
		const options = getEnumValues(TestType).map((v) => ({
			label: t(v),
			value: v,
		})) as Array<SelectableValue>;
		const arrayOrNonArrayFieldIndex = this.parent.schema.isArray ? `.${this.currentIndex}` : "";
		const [testUoM] = useFieldValue<TestUoMType>(`${this.parent.path}${arrayOrNonArrayFieldIndex}.${AttributeIdentifiers.TestUoM}`);

		function getTestTypeOptionsByTestUoM(options: Array<SelectableValue>): Array<SelectableValue> {
			switch (testUoM) {
				case TestUoMType.GramsPerDecilitre:
					return options.filter((o) => o.value === TestType.Hemoglobin);
				case TestUoMType.TimesUln:
					return options.filter((o) => o.value === TestType.LactateDehydrogenase);
				case TestUoMType.PerMicrolitre:
					return options.filter((o) => o.value === TestType.AbsoluteReticulocyteCount);
				case TestUoMType.PerBillionPerLitre:
					return options.filter((o) => o.value === TestType.PlateletCount || o.value === TestType.NeutrophilCount);
				default:
					return options;
			}
		}

		return {
			controlType: "typeahead",
			optionLabel: "label",
			property: "value",
			selectPropertyValue: true,
			options: getTestTypeOptionsByTestUoM(options),
			freeSolo: false,
		};
	}
}
